import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { post, checkHttpStatus} from "../../utils/RestUtilsWithAxios";
import {
  GET_ALL_PORTFOLIO,
} from "../../constants/uri";
import MaterialUIDatePicker from "../../components/EyatUIDatePicker";
import DownloadButtons from "../../components/PdfAndExcelDownloadButtons";
import PlatformBasedTables from "./PlatformBasedPortfolio";
import CurrencyBasedPortfolio from "./CurrencyBasedPortfolio";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import * as DownloadUtils from "../../utils/downloadUtils";
import * as Globals from "../../constants/globals";
import PortfolioPieChart from "../BalancePortfolio/partials/PortfolioPieChart";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    marginBottom: theme.spacing(2),
    margin: "auto",
    padding: 30,
    paddingTop: 20,
  },
  navButton: {
    maxWidth: "100%",
    marginLeft: 2,
    marginRight: 2,
    backgroundColor: Globals.COLOR_TRANSPARENT_RED,
    borderRadius: 4,
  },
  activeNavButton: {
    maxWidth: "100%",
    marginLeft: 2,
    marginRight: 2,
    backgroundColor: Globals.COLOR_FULL_RED,
    borderRadius: 4,
  },
  nav: {
    justifyContent: "space-around",
    height: "unset",
    padding: 5,
    borderRadius: 4,
    paddingLeft: 0,
    paddingRight: 0,
    marginBottom: theme.spacing(2),
  },
  navText: {
    color: "white",
    fontSize: 12,
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
    },
  },
  totalValueBox: {
    backgroundColor: Globals.COLOR_DARK_GRAY,
    padding: 10,
    borderRadius: 4,
    flex: 1,
    display: "flex",
    margin: 8,
  },
  totalValueText: {
    color: "white",
  },
  selectedValueBox: {
    padding: 10,
    borderRadius: 4,
    flex: 1,
    display: "flex",
    margin: 8,
  },
  textContainer: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  selectedMarketValue: {
    textAlign: "center",
    fontSize: 16,
    position: "absolute",
  },
  infoMsg: {
        marginBottom: theme.spacing(2),
        margin:'auto',
        padding: 30
    },
}));

/**
 * formatMonthOrDay
 * @param m
 * @return {*}
 */
function formatMonthOrDay(m) {
    if(m<10)
        return '0'+m;
    else
        return m;
}

/**
 * beginInit
 * @return {string}
 */
function beginInit() {
  var date = new Date();
    return date.getFullYear().toString()+(formatMonthOrDay(date.getMonth()+1)).toString()+
        (formatMonthOrDay(date.getDate())).toString();
}

/**
 * KvmksPortfolioDetails
 * @param props
 * @return {*}
 * @constructor
 */
function KvmksPortfolioDetails (props) {
  const classes = useStyles();
  const [pageTabValue, setPageTabValue] = React.useState(0);
  const [selectedDate, setSelectedDate] = React.useState(beginInit());
  const [dontShowUnderOneTL, setDontShowUnderOneTL] = React.useState(false);
  const [totalMarketValue, setTotalMarketValue] = React.useState(null);
  const [currencyTotalValueAndRatioList, setCurrencyTotalValueAndRatioList] = React.useState(null);
  const [platformTotalValueAndRatioList, setPlatformTotalValueAndRatioList] = React.useState(null);
  const [displayCryptoBalanceList, setDisplayCryptoBalanceList] = React.useState([]);
  const [originalCryptoBalanceList, setOriginalCryptoBalanceList] = React.useState([]);
  const [chartData, setChartData] = React.useState(null);
   
  React.useEffect(() => {
    setChartData(null)
    retrieveData(pageTabValue);
  }, [selectedDate]);

  /**
   * retrieveData
   * @param tabIndex
   */
    function retrieveData (tabIndex) {
      setOriginalCryptoBalanceList(null)
     console.log("qweqweqwewqewqeqweqweqweqwe")
      post(GET_ALL_PORTFOLIO,{'dateField': selectedDate})
            .then(function (response) {
              setOriginalCryptoBalanceList(response.data.cryptoBalanceList);
              setTotalMarketValue(response.data.totalMarketValue)
              setChartData(response.data.platformTotalValueAndRatioList)
              setPlatformTotalValueAndRatioList(response.data.platformTotalValueAndRatioList)
              setCurrencyTotalValueAndRatioList(response.data.currencyTotalValueAndRatioList);
              setDisplayCryptoBalanceList(response.data.cryptoBalanceList)
              switch(tabIndex) {
                case 0:
                      setChartData(response.data.platformTotalValueAndRatioList)
                break; 
                case 1: 
                      setChartData(response.data.currencyTotalValueAndRatioList)
                break;
              } 
            })
            .catch(function (error) {
              checkHttpStatus(error,props.intl);
            })
  }

  /**
   * isEmpty
   * @param obj
   * @return {boolean}
   */
  function isEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
    }
    return true;
  }

  /**
   * handleChange
   * @param event
   * @param newValue
   */
  function handleChange(event, newTabValue) {
    switch(newTabValue) {
      case 0: 
          console.log(platformTotalValueAndRatioList)
          setChartData(platformTotalValueAndRatioList)
      break; 
      case 1: 
          console.log(currencyTotalValueAndRatioList)
          setChartData(currencyTotalValueAndRatioList)    
      break;
    } 
    setPageTabValue(newTabValue);
  }

  /**
   * handleCheckBox
   */
  function handleCheckBox() {
   
    if(dontShowUnderOneTL){
      setDisplayCryptoBalanceList(originalCryptoBalanceList)
    }
    else{
      const filtered = originalCryptoBalanceList.filter(
        item => item.marketValue > 1
      );
      setDisplayCryptoBalanceList(filtered)
    }

    setDontShowUnderOneTL(!dontShowUnderOneTL);
  }

  /**
   * isChartVisible
   * @return {boolean}
   */
    function isChartVisible(){
        return chartData && chartData.length > 0
  }

  /**
   * downloadAsExcel
   * @param serviceName
   * @param fileName
   */
  function downloadAsExcel(serviceName, fileName) {
      post(serviceName,{'dateField': selectedDate, 'dontShowUnderOneTL': dontShowUnderOneTL})
        .then(function (response) {
        DownloadUtils.downloadFileByContentExcel(response.data, fileName, Globals.CONTENT_TYPE_EXCEL);
      })
      .catch(function (error) {
        checkHttpStatus(error,props.intl);
      })
    }


  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid
          container
          direction={isChartVisible() ? "row-reverse" : "row"}
          spacing={2}
          style={{ marginBottom: 16 }}
        >
          {(isChartVisible() && chartData?.length > 0) &&
            <PortfolioPieChart
              key={chartData.length} 
              data={chartData.filter(item => item && item.type)}
              totalMarketValue={totalMarketValue}
              isCrypto={true}
            />
          }
          <Grid item xs={12} md={isChartVisible() ? 4 : 6}>
            <div style={{ marginBottom: 24 }}>
              <MaterialUIDatePicker
                setContainerSelectedDate={setSelectedDate}
                dateString={selectedDate}
                disableFuture={true}
                disabled={pageTabValue === 3 || pageTabValue === 4 ? true : false}
              />
              <Typography
                variant="body2"
                style={{
                  display: "none",
                }}
              >
                {props.intl.formatMessage({
                  id: "PORTFOLIO.MESSAGE.PLEASE_ENTER_DATE",
                })}
              </Typography>
 
            </div>
           
            <div>
              <FormControlLabel
                style={{ marginBottom: 0 }}
                control={
                  <Checkbox
                    checked={dontShowUnderOneTL}
                    onChange={handleCheckBox}
                    value={dontShowUnderOneTL}
                    color="primary"
                  />
                }
                label={"Piyasa değerine göre 1 TL altındakileri gösterme"}
              ></FormControlLabel>
            </div>
          
          </Grid>
        </Grid>
        <BottomNavigation
          value={pageTabValue}
          onChange={handleChange}
          showLabels
          classes={{ root: classes.nav }}
        >
          
          <BottomNavigationAction
            label={
              <span className={classes.navText}>
                {"Platform (Üye) Detayında"}
              </span>
            }
            classes={{
              root: pageTabValue === 0 ? classes.activeNavButton : classes.navButton,
            }}
          />
          <BottomNavigationAction
            label={
              <span className={classes.navText}>
                {"Kripto Varlık Detayında"}
              </span>
            }
            classes={{
              root: pageTabValue === 1 ? classes.activeNavButton : classes.navButton,
            }}
          />
        </BottomNavigation>
        {pageTabValue === 0 ? (
          displayCryptoBalanceList ? (
            displayCryptoBalanceList.length > 0 ? (
              <div>
                <PlatformBasedTables
                  intl={props.intl}
                  securities={displayCryptoBalanceList}
                  selectedDate = {selectedDate}
                />
               
              </div>
            ) : (
              <Typography
                align="center"
                classes={{ h6: classes.textContainer }}
                variant="h6"
              >
                {props.intl.formatMessage({
                  id: "PORTFOLIO.COMMON.NO_DATA_MESSAGE",
                })}
              </Typography>
            )
          ) : null
        ) : pageTabValue === 1 ? (
          displayCryptoBalanceList ? (
            !isEmpty(displayCryptoBalanceList) ? (
              [
                <CurrencyBasedPortfolio
                  intl={props.intl}
                  securities={displayCryptoBalanceList}
                  selectedDate = {selectedDate}
                />,
                /*
                <DownloadButtons
                  pdfOnClick={() =>
                    printExtremTableItems(
                      Object.keys(displayCryptoBalanceList),
                      Object.values(displayCryptoBalanceList),
                      sbHeadRows,
                      1,
                      "KRİPTO VARLIK DETAYINDA BAKİYE RAPORU - " +
                        formatDate(selectedDate)
                    )
                  }
                  excelOnClick={() =>
                    downloadAsExcel(
                      DOWNLOAD_EXCEL_SECURITY_BASED_PORTFOLIO,
                      "Kripto Varlık Detayında " + selectedDate + ".xls"
                    )
                  }
                />*/,
              ]
            ) : (
              <Typography
                align="center"
                classes={{ h6: classes.textContainer }}
                variant="h6"
              >
                {props.intl.formatMessage({
                  id: "PORTFOLIO.COMMON.NO_DATA_MESSAGE",
                })}
              </Typography>
            )
          ) : null
        ) :
          <Typography align='center' classes={{h6: classes.textContainer}} variant='h6'>
              {props.intl.formatMessage({id:"PENDING_MESSAGE"})} 
          </Typography>  
      }
        
      </Paper>
      <Paper  className={classes.infoMsg}>
        <Grid container style={{backgroundColor: "white"}}>
            <Typography display="inline"  variant="subtitle1"
            
            ><div style={{display:'flex', flexDirection:'column'}}>
              <>{"  1. Kripto Varlık İşlemleri portföy ve bakiyesi, ilgili platformlar tarafından MKK'ya iletilen kayıtlar esas alınarak bilgilendirme amaçlı sunulmakta olup, MKK tarafından oluşturulmamaktadır. Kripto varlık bilgileri gecikmeli yansıyabilir. Piyasa değeri anlık değeri yansıtmamaktadır."}<br /></>
              <>{"  2. Bilgilerin içeriği, kapsamı, güncelliği ve aktarım sıklığı, ilgili kripto varlık platformların veri iletim süreçlerine bağlı olarak değişiklik gösterebilir. Uyumsuzluk durumunda verilerin düzeltilmesi için ilgili kripto varlık platformuna başvurabilirsiniz."}<br /></>
              <>{"  3. Uygulamada yer alan kripto varlıklara ilişkin bilgiler yalnızca yatırımcıların platformlarda bulunan kripto varlıklarına ilişkin bilgilendirme niteliğinde olup yatırım danışmanlığı, alım-satım yönlendirmesi veya getiri taahhüdü olarak değerlendirilemez."}<br /></> 
              <>{"  4. Bakiye sorgulamanızda sağlanan veriler, MKK’ya hesabınızın bulunduğu Platformlar ve varsa saklama kuruluşları tarafından iletilen verilerin MKK tarafından karşılaştırılması sonucu oluşmaktadır. MKK’ya iletilmemiş bakiye bilgileriniz bakımından MKK tarafından yapılacak bir işlem bulunmamakta olup, hesabınızın bulunduğu kuruluşlara başvurmanız mümkündür."}</>
            </div>
            </Typography>
        </Grid>
    </Paper>
    </div>
  );
}

/**
 * injectIntl
 */
export default injectIntl(connect(null)(KvmksPortfolioDetails));
